import React from 'react';

import {
  EditWriteRequestModalDocument,
  NetSuiteWriteRequestFormat,
  useEditWriteRequestModalQuery,
  useRegenerateWriteRequestMutation,
  useSaveAndValidateWriteRequestMutation
} from 'generated/graphql';



export interface IData {
  formattedRequestData: string;
  requestType: NetSuiteWriteRequestFormat;
  validationErrors: string[];
}

export function useQuery(writeRequestId: string) {
  const tuple = useEditWriteRequestModalQuery({
    variables: {
      writeRequestId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        formattedRequestData: JSON.stringify(tuple.data?.netSuiteWriteRequest?.requestData, null, 2),
        requestType: tuple.data?.netSuiteWriteRequest?.format ?? 'customer',
        validationErrors: tuple.data?.netSuiteWriteRequest?.validationErrors ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveAndValidateWriteRequest(writeRequestId: string) {
  const [fnMutate, tuple] = useSaveAndValidateWriteRequestMutation({
    refetchQueries: [
      {
        query: EditWriteRequestModalDocument,
        variables: {
          writeRequestId
        }
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    async (requestData: unknown) => {
      await fnMutate({
        variables: {
          input: {
            writeRequestId,
            requestData
          }
        }
      });
    },
    [fnMutate, writeRequestId]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}



export function useRegenerateWriteRequest(id: string) {
  const [fnMutate, tuple] = useRegenerateWriteRequestMutation({
    refetchQueries: [
      {
        query: EditWriteRequestModalDocument,
        variables: {
          writeRequestId: id
        }
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    async () => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate, id]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}

